import React from 'react';
import styled from 'styled-components';

const TaxSelector = ({userChoice, onChange, selectState}) => {

    return (
        <TaxSelectorStyled className='TaxSelector'>
            <select value={ selectState } onChange={ onChange } >
                    {
                        userChoice.map((uc, idx) => {
                            return <option key={ idx } value={ uc } >{uc}</option>;
                        })
                    }
            </select>
        </TaxSelectorStyled>
    );
}

export default TaxSelector;

const TaxSelectorStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 15px;

    select {
        min-width: 275px;
        min-height: 50px;
        border-radius: 25px;
        padding: 0px 20px;
        appearance: none;
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d='M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z'/></svg>");
        background-repeat: no-repeat;
        background-position: right 1rem center;
        background-size: 1rem;
    }
`;